import { ofType } from 'redux-observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, setTriggersAction } from '../../reducers/actions';
import { ActionService, TriggerService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';
import { listToMap } from '../../utils/transform';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_TRIGGERS),
    switchMap(action =>
      TriggerService.getByWorkflowId(
        action.siteId,
        action.workflowId,
        store
      ).pipe(
        switchMap(data => {
          return forkJoin(
            of(data),
            ...data.map(trigger =>
              ActionService.getByTriggerId(trigger.id, store)
            )
          );
        }),
        map(([data, ...actions]) => {
          let triggersMap = listToMap(data);
          actions
            .reduce((all, list) => [...all, ...list], [])
            .forEach(action => {
              if (action.trigger.id in triggersMap) {
                triggersMap[action.trigger.id].action = action;
              }
            });
          return setTriggersAction(Object.values(triggersMap));
        }),
        catchError(retryAuthentication(action$, 'epics/triggers/getTriggers'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/triggers/getTriggers.js